import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App'
import './app/globals.css'
import { asyncWithLDProvider, basicLogger } from 'launchdarkly-react-client-sdk';
import { Config } from './app/shared/utils/config';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './app/shared/api/queryClient';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root')!;
const root = createRoot(container);
const renderApp: boolean = window.self === window.top;
const mockFlags = (window as any).__MOCK_LD_FLAGS__;

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: Config.LaunchDarklyKey,
    deferInitialization: true,
    reactOptions: {
        useCamelCaseFlagKeys: false,
    },
    options: {
        logger: basicLogger({ level: 'warn' }),
        bootstrap: mockFlags,
    },
    context: {
        kind: 'client',
        anonymous: true,
    },
  });

  root.render(
      renderApp ? (
          <React.StrictMode>
            <BrowserRouter>
              <QueryClientProvider client={queryClient}>
                <LDProvider>
                    <App />
                </LDProvider>
              </QueryClientProvider>
            </BrowserRouter>
          </React.StrictMode>
      ) : (
          <div>Error loading resource</div>
      )
  );
})();